import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '@environment';
import { HttpClient } from '@angular/common/http';
import { BulkUpdateRepliesVisibilityBody } from '../../core/models/bulk-update-replies-visibility-body.model';
import { BulkOperationResultWithData } from '../../core/models/bulk-operation-result-with-data.model';

@Injectable({
    providedIn: 'root',
})
export class ReplyBulkOperationsService {
    constructor(private httpClient: HttpClient) {}

    changeRepliesVisibility(
        ticketId: number,
        data: BulkUpdateRepliesVisibilityBody,
    ): Observable<BulkOperationResultWithData> {
        return this.httpClient.patch<BulkOperationResultWithData>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/replies/bulkOperations/visibility',
            data,
        );
    }

    deleteReplies(ticketId: number, replyIds: number[]): Observable<BulkOperationResultWithData> {
        return this.httpClient.delete<BulkOperationResultWithData>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/replies/bulkOperations/deletion',
            { body: replyIds },
        );
    }
}
